import React, { useMemo } from "react"
import styled from "styled-components"
import { Container, Title as T, Description as D, Button } from "."
import astGetCustomField from "../../utils/astGetCustomField"

type CtaLargeNoImageProps = {
  cta: {
    node: {
      id: string
      title: string
      slug: string
      feature_image: string
      childHtmlRehype: {
        htmlAst: any
      }
    }
  }
}

const CtaLargeNoImage: React.FC<CtaLargeNoImageProps> = ({ cta }) => {
  const htmlAst = cta?.node?.childHtmlRehype?.htmlAst
  const ctaHtmlAst = useMemo(() => {
    return htmlAst?.children?.find(
      child => child.tagName === "cta-large-no-image"
    )
  }, [htmlAst?.children])

  const ctaTitle = useMemo(() => astGetCustomField(ctaHtmlAst, "title"), [
    ctaHtmlAst,
  ])
  const ctaDescription = useMemo(
    () => astGetCustomField(ctaHtmlAst, "description"),
    [ctaHtmlAst]
  )
  const ctaLink = useMemo(() => astGetCustomField(ctaHtmlAst, "link"), [
    ctaHtmlAst,
  ])
  const ctaButtonText = useMemo(
    () => astGetCustomField(ctaHtmlAst, "buttonText"),
    [ctaHtmlAst]
  )

  return (
    <Container
      style={{
        background: "#ffffff",
        border: "1px solid #03192d",
      }}
      className="not-prose"
    >
      <Images>
        <Image src="/images/blog/cta/cta-bg-left.png" align="left" alt="" />
        <Image src="/images/blog/cta/cta-bg-right.png" align="right" alt="" />
      </Images>
      {!!ctaLink && (
        <Content>
          {!!ctaTitle && <Title>{ctaTitle}</Title>}
          {!!ctaDescription && <Description>{ctaDescription}</Description>}
          {!!ctaButtonText && <Button>{ctaButtonText}</Button>}
          <Link
            href={ctaLink}
            data-cta-title={ctaTitle || ""}
            data-cta-description={ctaDescription || ""}
            data-cta-button-text={ctaButtonText || ""}
          ></Link>
        </Content>
      )}
    </Container>
  )
}

const Title = styled(T)`
  font-size: 2rem;
`

const Description = styled(D)`
  margin: 8px 0 0;
`

const Link = styled.a`
  border-bottom: none !important;
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`

const Content = styled.div`
  padding: 30px 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  position: relative;

  @media (min-width: ${props => props.theme.breakpointsObj.sm}) {
    padding: 24px 40px;
  }
`

const Images = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  display: none;

  @media (min-width: ${props => props.theme.breakpointsObj.lg}) {
    display: block;
  }
`

const Image = styled.img<{ align: "left" | "right" }>`
  height: 100%;
  width: auto;
  position: absolute;
  top: 0;
  ${props => (props.align === "left" ? "left: 0;" : "right: 0;")}
`

export default CtaLargeNoImage
